module.exports = __webpack_public_path__ + "static/media/avatar30.f1073fd6.png";